(function () {
  'use strict';

  // Prevent double-binding if this script somehow loads twice
  if (window.__upsellAtcDelegationBound) return;
  window.__upsellAtcDelegationBound = true;

  document.addEventListener('submit', handleUpsellSubmit, true);

  function handleUpsellSubmit(evt) {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;

    const wrapper = form.closest('[data-upsell-form]');
    if (!wrapper) return; // not an upsell form, normal handlers run

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    const submitBtn = form.querySelector('[data-upsell-atc]') || form.querySelector('[type="submit"]');
    if (!submitBtn || submitBtn.getAttribute('aria-disabled') === 'true') return;

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    const spinner = form.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');

    const cartDrawerEl = document.querySelector('cart-drawer');
    const formData = new FormData(form);

    if (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawerEl.getSectionsToRender().map((s) => s.id).join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawerEl.setActiveElement === 'function') {
        cartDrawerEl.setActiveElement(document.activeElement);
      }
    }

    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status) {
          console.error('[UpsellATC] add failed:', response.message || response.description);
          const soldOutMessage = submitBtn.querySelector('.sold-out-message');
          if (soldOutMessage) {
            submitBtn.setAttribute('aria-disabled', 'true');
            submitBtn.querySelector('span:not(.sold-out-message)')?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
          return;
        }

        

        const publishCartUpdate = () => {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'upsell-standalone',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
        };

        if (!cartDrawerEl) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        // Prefer the sections already returned by /cart/add.js (no 2nd fetch)
        if (response.sections) {
          cartDrawerEl.renderContents({ id: formData.get('id'), sections: response.sections });
          publishCartUpdate();
          return;
        }

        // Fallback: fetch sections separately if add.js didn't include them
        const sectionIds = cartDrawerEl.getSectionsToRender().map((s) => s.id);
        fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`)
          .then((r) => r.json())
          .then((sectionsData) => {
            cartDrawerEl.renderContents({ id: formData.get('id'), sections: sectionsData });
            publishCartUpdate();
          });
      })
      .catch((err) => console.error('[UpsellATC] error:', err))
      .finally(() => {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
      });
  }
})();